import React from 'react'
import { IconSVGType } from '../../../types/icons'

/**
 * @param {IconSVGType} props
 */
const FileDOCIcon = (props: IconSVGType) => {
  return (
    <svg
      className={props.className}
      fill='none'
      height={props.height}
      viewBox={props.viewBox || '0 0 24 24'}
      width={props.width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='#5D5D5D'
        fillRule='evenodd'
        d='M4.01 4c0-1.1.89-2 1.99-2h7.17c.53 0 1.04.21 1.41.59l4.83 4.83c.38.37.59.88.59 1.41V20c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.01-16ZM13 3.5V8c0 .55.45 1 1 1h4.5L13 3.5ZM6.773 17h-1.61v-4.9h1.645c1.736 0 2.604.917 2.604 2.373v.105c0 1.456-.882 2.422-2.64 2.422Zm1.106-2.499c0-.777-.406-1.064-1.03-1.064h-.174v2.226h.175c.623 0 1.029-.294 1.029-1.064v-.098Zm6.602.105c0 1.47-.987 2.499-2.331 2.499-1.344 0-2.317-1.015-2.317-2.485v-.126c0-1.47.98-2.499 2.324-2.499 1.35 0 2.324 1.015 2.324 2.485v.126Zm-3.122-.007c0 .728.308 1.155.798 1.155.49 0 .79-.42.79-1.148v-.105c0-.728-.307-1.155-.797-1.155-.483 0-.791.42-.791 1.148v.105Zm7.708 1.526c-.357.525-.938.973-1.89.973-1.225 0-2.275-.924-2.275-2.478v-.119c0-1.526 1.05-2.499 2.33-2.499.834 0 1.415.364 1.807.924l-1.022.938c-.154-.245-.378-.462-.756-.462-.476 0-.82.406-.82 1.127v.028c0 .777.372 1.141.827 1.141.392 0 .616-.224.777-.476l1.022.903Z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default FileDOCIcon
